module.exports = __webpack_public_path__ + "img/shift-selection.cfdff4f3.jpg";